import styled from 'styled-components';
import ContentText from '../atoms/ContentText';
import { memo } from 'react';

type TagProps = {
  theme?:
    | 'disabled'
    | 'info'
    | 'error'
    | 'seminar'
    | 'plus'
    | 'forum'
    | 'waiting'
    | 'processing'
    | 'reject'
    | 'approve'
    | 'campaign'
    | 'lime'
    | 'limited'
    | 'unread';
  tagColor?: string;
  className?: string;
  children: any;
  small?: boolean;
  fontColor?: string;
  forceRounded?: boolean;
};
const Tag: React.FC<TagProps> = (props) => {
  return (
    <TagWrapper
      theme={props.theme}
      className={props.className}
      $small={props.small}
      $tagColor={props.tagColor}
      forceRounded={props.forceRounded}
    >
      <ContentText type="label-l" color={props.fontColor ?? 'white'}>
        {props.children}
      </ContentText>
    </TagWrapper>
  );
};
const TagWrapper = styled.div<{
  theme?:
    | 'disabled'
    | 'info'
    | 'error'
    | 'seminar'
    | 'plus'
    | 'forum'
    | 'waiting'
    | 'processing'
    | 'reject'
    | 'approve'
    | 'campaign'
    | 'lime'
    | 'limited'
    | 'unread';
  $small?: boolean;
  $tagColor?: string;
  fontColor?: string;
  forceRounded?: boolean;
}>`
  width: fit-content;
  height: fit-content;
  border-radius: 4px;
  white-space: nowrap;
  padding: ${(props) => (props.$small ? '0px 4px' : '0 8px')};
  min-width: ${(props) => (props.forceRounded ? '17.5px' : '0px')};
  background: ${({ theme, $tagColor }) => {
    switch (theme) {
      case 'disabled':
        return 'var(--tag-disabled,#8e8e8e)';
      case 'error':
        return 'var(--color-red,#c12827)';
      case 'info':
        return 'var(--info-main,#4087f2)';
      case 'seminar':
        return 'var(--color-orange,#f28300)';
      case 'plus':
        return 'var(--node-process, #bea66b)';
      case 'forum':
        return 'var(--rose-400, #B55160)';
      case 'waiting':
        return 'var(--amber-400, #b58a1a)';
      case 'processing':
        return 'var(--blue-400, #4577b4)';
      case 'reject':
        return 'var(--red-400, #b35151)';
      case 'approve':
        return 'var(--green-400, #35a15c)';
      case 'campaign':
        return 'var(--yellow-400, #b4930f)';
      case 'lime':
        return 'var(--lime-400, #75a626)';
      case 'limited':
        return 'var(--lightblue-400, #2988b3)';
      default:
        if ($tagColor) return $tagColor;
        else return 'var(--dark-dullgreen, #4f6862)';
    }
  }};
  ${({ theme }) => {
    switch (theme) {
      case 'unread':
        return `
        background: #B91C1C;
        font-weight: 700;
        text-align: center;
    `;
    }
  }}
`;
export default memo(Tag);
